import NewsTile from "./NewsTile";
export default NewsTile;
